import React from "react";

const FormErrorMessage = ({ error, messages }) => {
  if (!error) return null;
  
  const errorMessage =
  (error.type && messages?.[error.type]) || error.message || error || "Error in field";
  return (
    <span className="text-danger fs-13 text-red-400">
      {errorMessage}
    </span>
  );
};

export default FormErrorMessage;
